import { render, staticRenderFns } from "./SenderCodeMng.vue?vue&type=template&id=82281b12"
import script from "./SenderCodeMng.vue?vue&type=script&lang=js"
export * from "./SenderCodeMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports